import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { LoginImport } from './Import'
const { login_banner, UserLoginForm, Aos, } = LoginImport

export default function UserLogin() {

    Aos.init();
    const [toggle, setTogggle] = useState(false)

    return (
        <>
            <Helmet>
                <title>Salon Management System Admin Panel</title>
            </Helmet>
            <div className='row side_bg g-0'>
                <div className="col-sm-12 col-lg-7 my-auto">
                    <div>
                        <div className='p-4'>
                            {/* <img src="./favicon.ico" alt="fav" className='img-fluid side_fav_img' /> */}
                            {/* <h6 className='mt-2 dark_blue'>Welcome to My Salon Hub</h6> */}
                        </div>

                        <div className='text-center'>
                            <img src={login_banner} alt="bg" className='img-fluid rounded'  />
                        </div>

                        <div className="py-4 px-4 mt-5 pt-5">
                            <div className='d-sm-none d-lg-flex justify-content-between align-items-center'>
                                <div className='fw-medium dark_blue' style={{ fontSize: '14px' }}>© Copyright 2025 - My Salon Hub. All Right Reserved</div>
                                <div className='fw-medium grey' style={{ fontSize: '14px' }}>Developed by <u className='dark_blue' style={{ cursor: 'pointer' }} onClick={() => window.open('https://www.techlene.com/', '_blank')}>Techlene Software Solutions Pvt. Ltd.</u></div>
                            </div>
                        </div>
                    </div>
                </div>

                {!toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">
                        <UserLoginForm setTogggle={setTogggle} />
                    </div>
                    : ''
                }

                {toggle ?
                    <div className="col-sm-12 col-lg-5 position-relative" data-aos="fade-left" data-aos-duration="1000">

                    </div>
                    : ''
                }
            </div>
        </>
    )
}
